const DATA_VERSION_OPTIONS = [
  {
    value: "1",
    title: "Data version 1",
    description:
      "Enables downstream processing of older questionnaires without complex features",
  },
  {
    value: "3",
    title: "Data version 3",
    description:
      "Enables downstream processing of newer questionnaires with complex features",
  },
];

export default DATA_VERSION_OPTIONS;
